var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-config-container" }, [
    _c(
      "div",
      { staticClass: "list-container" },
      [
        _c(
          "el-form",
          {
            staticClass: "compact-search-form",
            attrs: { inline: true, model: _vm.searchForm },
          },
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  staticStyle: { width: "220px" },
                  attrs: { placeholder: "活动名称", clearable: "" },
                  model: {
                    value: _vm.searchForm.keywords,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "keywords", $$v)
                    },
                    expression: "searchForm.keywords",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "140px" },
                    attrs: { placeholder: "活动状态", clearable: "" },
                    model: {
                      value: _vm.searchForm.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "status", $$v)
                      },
                      expression: "searchForm.status",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "上架", value: 1 } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "下架", value: 0 } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                  },
                  on: { change: _vm.changeTime },
                  model: {
                    value: _vm.times,
                    callback: function ($$v) {
                      _vm.times = $$v
                    },
                    expression: "times",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "form-actions" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.fetchList } },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.addAct } },
                  [_vm._v("添加活动")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData, stripe: "", border: "" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "id", label: "ID", align: "center", width: "80" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "activityName",
                label: "活动名称",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "activityTitle",
                label: "活动标题",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "背景图", align: "center", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.bgImage
                        ? _c("el-image", {
                            staticStyle: { width: "60px", height: "60px" },
                            attrs: { src: scope.row.bgImage, fit: "cover" },
                          })
                        : _c("span", [_vm._v("-")]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "rewardDesc", label: "奖励", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "limitCount",
                label: "可领奖次数",
                align: "center",
                width: "100",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "publishedCount",
                label: "已发布",
                align: "center",
                width: "90",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "receivedCount",
                label: "已领奖",
                align: "center",
                width: "90",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "活动时间", align: "center", width: "340" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(_vm.formatDate(scope.row.startTime)) +
                          " - " +
                          _vm._s(_vm.formatDate(scope.row.endTime))
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "活动状态", align: "center", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        on: {
                          change: function ($event) {
                            return _vm.changeStatus(
                              scope.row.id,
                              scope.row.status
                            )
                          },
                        },
                        model: {
                          value: scope.row.status,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "status", $$v)
                          },
                          expression: "scope.row.status",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                align: "center",
                fixed: "right",
                width: "380",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleEdit(scope.row)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.copyPagePath(scope.row)
                            },
                          },
                        },
                        [_vm._v("复制地址")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleRecord(scope.row)
                            },
                          },
                        },
                        [_vm._v("发帖记录")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleReward(scope.row)
                            },
                          },
                        },
                        [_vm._v("领奖记录")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.searchForm.page,
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.searchForm.limit,
                total: _vm.searchForm.total,
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.qrDialogVisible,
              width: "560px",
              "before-close": function () {
                return (_vm.qrDialogVisible = false)
              },
              center: "",
            },
            on: {
              "update:visible": function ($event) {
                _vm.qrDialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              { staticStyle: { "text-align": "center", padding: "10px 0" } },
              [
                _vm.qrImage
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-bottom": "18px",
                          "font-size": "24px",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(_vm.qrObj.activityName))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.qrImage
                  ? _c("el-image", {
                      staticStyle: {
                        "max-width": "320px",
                        "max-height": "320px",
                      },
                      attrs: { src: _vm.qrImage, fit: "contain" },
                    })
                  : _c("div", [_vm._v("暂无二维码图片")]),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }